export default function() {
  return {
    namespaced: true,
    state: {
      queue: [],
    },
    mutations: {
      inqueueMapEvent(state, event) {
        state.queue.push(event);
      },
      dequeueMapEvent(state) {
        state.queue.shift();
      },
    },
    actions: {
      inqueueMapEvent({ commit }, event) {
        commit('inqueueMapEvent', event);
      },
      dequeueMapEvent({ commit }) {
        commit('dequeueMapEvent');
      },
    },
  }
}